export class ClsPedidoDomiciliarioModel {
  public PD_TERCERO_ID: number

  public PD_PEDIDO_ID: number;

  public USU_ID: number;

  public IP_EQUIPO: string;
}
